import DOMPurify from "dompurify";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { CardText } from "reactstrap";
import shareIcon from "../assets/img/shareIcon.svg";
import shareIconL from "../assets/img/shareIconL.svg";
import { checkLiked } from "../store/actions/GlobalAction";

const fallbackUrl =
  "https://images.unsplash.com/photo-1509721434272-b79147e0e708?ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=80";

const HeroSectionCard = ({ slideImages, menuID, customerID, content }) => {
  const sanitizedHtml = DOMPurify.sanitize(content);
  const dispatch = useDispatch();
  const { darkMode } = useSelector((state) => state.global);
  const [copied, setCopied] = useState(false);

  const handleClick = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    } catch (err) {
      console.error("Failed to copy URL: ", err);
    }
  };

  useEffect(() => {
    if (menuID) {
      dispatch(checkLiked(menuID, customerID));
    }
  }, [customerID, dispatch, menuID]);

  return (
    <>
      <div className="slider-wrapper rounded-lg border-0 overflow-hidden">
        {Array.isArray(slideImages) && slideImages?.length > 1 ? (
          <Swiper
            modules={[Autoplay]}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            loop={slideImages.length > 1}
            speed={300}
            slidesPerView={1}
          >
            {slideImages &&
              slideImages.map((slideImage, index) => (
                <SwiperSlide key={index} className="slides__section">
                  <img
                    src={slideImage}
                    alt={`Slide ${index + 1}`}
                    onError={(e) => (e.target.src = fallbackUrl)}
                    style={{
                      width: "100%",
                      height: "350px",
                      objectFit: "cover",
                    }}
                  />
                </SwiperSlide>
              ))}
          </Swiper>
        ) : slideImages?.length == 1 ? (
          <img
            src={slideImages}
            alt="Slide"
            onError={(e) => (e.target.src = fallbackUrl)}
            style={{
              width: "100%",
              height: "350px",
              objectFit: "cover",
            }}
          />
        ) : (
          <img
            src={fallbackUrl}
            alt="Default Slide"
            style={{
              width: "100%",
              height: "350px",
              objectFit: "cover",
            }}
          />
        )}
      </div>

      {content?.trim().replace(/<[^>]+>/g, "") && (
        <div
          className="description-wrapper"
          style={{
            backgroundColor: "rgba(128, 128, 128, 0.3)",
            padding: "1.5rem",
            borderRadius: "0.75rem",
            marginTop: "1rem",
          }}
        >
          <CardText
            className="fs-6 mb-2"
            style={{ color: darkMode ? "#fff" : "#000" }}
            dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
          />

          <div className="d-flex justify-content-end align-items-center mt-2">
            <img
              alt="Share"
              src={darkMode ? shareIcon : shareIconL}
              className="cursor-pointer"
              style={{ height: 22 }}
              onClick={handleClick}
            />
            {copied && (
              <span
                className="ms-2 text-success fw-bold"
                style={{ fontSize: "0.85rem" }}
              >
                Copied!
              </span>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default HeroSectionCard;
